<!-- LazyVideoPlayer.vue (Conceptual Refactor) -->
<template>
  <div class="lazy-video-container" @click="playVideo">
    <!-- This part shows before the user clicks -->
    <template v-if="!isClicked">
      <img :src="thumbnailUrl" class="video-thumbnail" alt="Video thumbnail" />
      <div class="play-button-overlay">
        <!-- A nice SVG play button -->
        <svg class="play-icon" viewBox="0 0 24 24">
          <path fill="currentColor" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
        </svg>
      </div>
    </template>

    <!-- This iframe is only rendered after the user clicks -->
    <iframe
      v-if="isClicked"
      width="100%"
      height="300"
      :src="videoUrlWithAutoplay"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :title="title"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'LazyVideoPlayer',
  props: ['videoId', 'title'],
  data() {
    return {
      isClicked: false,
    };
  },
  computed: {
    thumbnailUrl() {
      // Use YouTube's max resolution default thumbnail for better quality
      return `https://i.ytimg.com/vi/${this.videoId.split("?")[0]}/maxresdefault.jpg`;
    },
    videoUrlWithAutoplay() {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1`;
    },
  },
  methods: {
    playVideo() {
      this.isClicked = true;
    },
  },
};
</script>

<style scoped>
.lazy-video-container {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px; /* Match the card's border-radius */
}
.video-thumbnail {
  width: 100%;
  display: block;
  transition: transform 0.3s ease;
}
.lazy-video-container:hover .video-thumbnail {
  transform: scale(1.05);
}
.play-button-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}
.lazy-video-container:hover .play-button-overlay {
  background-color: rgba(0, 0, 0, 0.6);
}
.play-icon {
  width: 60px;
  height: 60px;
  color: white;
  transition: transform 0.3s ease;
}
.lazy-video-container:hover .play-icon {
  transform: scale(1.1);
}
iframe {
  border-radius: 12px;
}
</style>
